export default {
    test: 'hello world',
    loading: 'Loading...',
    from_prepop_get_loan: 'Continue with your application to get your loan',
    you_were_referred_by: 'You were referred by',
    components: {
        form: {},
        field: {},
        smsverification: {
            edit_phone: 'Edit phone',
            verify_code: 'Verify',
            verified_success: 'Your phone number has been successfully verified!',
            max_attempts_reached: 'You have reached the maximum number of attempts.',
            verification_code_sent: 'Your will receive a verification code by SMS, standard messaging or data rates may apply.',
            new_accounts_must_verify: 'For security reasons new accounts must verify their phone numbers.',
            last_attempt: 'You have 1 attempt left.',
            sent_sms_to: 'Sent SMS code to:',
            resend_code: 'Request another code',
            resend_code_in: 'You can request another code in',
            seconds: 'seconds',
            skip_verification_car_loan: `<small><b class="text-primary">Important:</b> You can skip this step but your options may be limited.</small>`,
            skip_verification_account_creation: `<small><b class="text-primary">Important:</b> You can skip this step by pressing the button below, but you won’t be able to create an account.</small>`,
            enter_valid_code: 'Please enter a valid verification code.',
            enter_valid_phone: 'Please enter a valid canadian phone number.',
            sms_code_could_not_send: "We couldn't send an SMS code to the provided number. Please ensure it's correct and try again.",
            sms_code_is_incorrect: "The code you provided is incorrect. Please try again.",
            enter_phone: 'Enter your phone number',
            enter_code: 'Enter the verification code',
        }
    },
    validations: {
        invalid_data: 'Invalid data provided',
        postal_code_format: 'The postal code must be in format A9A9A9',
        required_field: 'This field is required',
        email_required: 'A valid email is required',
        phone_format: 'The phone number must be 10 digits (no spaces or hyphens)',
        phone_canadian: 'A valid canadian phone number is required (10 digits, no spaces or hyphens)',
        password: 'Password must be at least 8 characters, contain one uppercase letter, one lowercase letter and one number.',
        password_confirmation: 'Passwords do not match.',
        email_confirmation: 'Emails do not match.',
        name: 'Only alphabetic characters are allowed',
        dob: 'The date of birth must be in format YYYY-MM-DD',
        date: 'The date must be in format YYYY-MM-DD',
        sin: 'The SIN must be 9 digits (no spaces or hyphens)',
        invalid_character: 'Invalid character',
        numeric: 'Only numbers are allowed',
        drivers_license: 'You must be 18+ and hold a driver\'s license in order to qualify for a car loan',
        address_required: 'Address is required'
    },
    steps: {
        titles: {
            requested_amount: 'How much would you like to borrow?',
            requested_amount_debt: 'How much do you need to consolidate your debt?',
            product_purpose: 'What is the purpose of the loan?',
            cc_debt_amount: 'Credit Card Debt Amount',
            unsecured_debt_amount: 'Total Other Unsecured Debt',
            in_credit_situation: 'What is your estimated credit score?',
            income_type: 'Select your main income source',
            income_type_other: 'Do you have any other sources of income? <br><small>Select all that apply</small>',
            direct_deposit: 'Do you receive your income by direct deposit?',
            monthly_income: 'Select your monthly income',
            monthly_income_input: 'Enter your monthly income',
            monthly_other_income_input: 'Enter your monthly income',
            address: 'What is your address?',
            address_length_months: 'How long have you been at this address?',
            address_length_months_current: 'How long have you been at your current address?',
            own_home: 'Are you a homeowner?',
            living_situation: 'Tell us about your living situation',
            dob: 'What is your date of birth?',
            employer_information: 'Please enter your employment information',
            employed_months: 'How long have you been at this job?',
            pay_frequency: 'How often do you get paid?',
            pay_date1: 'What is your next pay date?',
            flinks_personal_loan: 'Select the bank account you want your money deposited to',
            flinks_car_loan: 'Confirm the account you wish to make your auto payments with',
            flinks_powersports: 'Confirm the account you wish to make your payments with',
            how_to_contact: 'How can we reach you?',
            phone_verification: 'Phone Verification',
            lets_create_your_account: "Let's create your account!",
            create_comparehub_account: "Do you want to create an account with us?",
            citizen_status: "Select your citizenship status",
            credit_card_debt_amount: "Credit Card Debt Amount",
            is_last_step: "This is the last step!",
            wants_equifax_verification: "Do you want to get verified with Equifax to obtain your FREE credit score and report?",
            confirm_information: "Please confirm your information below before continuing",
            sms_verification: 'Please confirm your phone number with the verification code that will be sent to your phone',
            lets_get_you_approved: "Let's get you approved!",
            postal_code: 'Enter your postal code',

            // car loan application
            car_request_type: 'Select the type of car you want to buy',
            car_request_monthly_budget: "What's your monthly budget?",
            car_in_credit_situation: "What is your estimated credit score?",
            car_request_sms_verification_code: "Please verify your vehicle preference by requesting a phone verification code",

            // life insurance
            requested_amount_life_insurance: 'How much coverage would you like?',
            what_province: 'What province do you live in?',
            select_gender: 'Select your gender',
            title_salutation: 'Salutation',
            what_is_your_name: 'What is your name?',

            // powersports
            what_are_you_looking_for: 'What are you looking to buy?',
            requested_amount_powersports: 'What is the value of the item you want to finance?',

            // business loan
            business_start_date: 'Business start date',
            equity: 'Equity',
            business_assets: 'Business Assets',
            company_information: 'Company Information',
            notice_of_assessment: 'Notice of Assessment (NOA)',
        },
        textTop: {
            hard_credit_check: `<div class="col-md-12 py-2" style="margin-top:30px;">To maximize your chance of finding a service provider, we recommend you authorize our provider network with permission to obtain credit reports from credit reporting agencies to assess your credit history and make approval decisions. By selecting "<b class="text-secondary">Maximize my approval chances</b>" matched provider(s) can check your credit report to make complete approval decisions based on your request and you can be funded faster. Otherwise, you agree that your consent is limited only to a soft credit check and you are limiting your approval opportunities. Your consent is valid until you notify the matched provider of your consent withdrawal.</div>`,
            unsecured_debt_amount_definition: `<p class="text-muted my-3 text-center">Unsecured debt refers to payday or personal loans and telecom bills, but excludes credit card balances, car loans and mortgages.</p>`,
            create_comparehub_account_benefits: `
                <p>By creating an account you can:
                    <ul>
                        <li>Increase your qualification chances</li>
                        <li>Track your application history</li>
                        <li>Speed up future applications</li>
                        <li><b>Get your free Equifax credit score!</b></li>
                    </ul>
                </p>
                <h6 class="text-center text-dark mt-3">Creating Your Free Credit Score Account Won't Impact Your Credit</h6>
            `,
            get_options_with_consent: `<p class="text-muted h5 my-3 text-center">Are you ready to receive your recommendations by electronic messages and see your loan options?</p>`,
            prequalify_best_providers: `<p class="text-muted h5" style="text-align: center;">Continuing will help us pre-qualify you with the best providers</p>`,
        },
        textBottom: {
            flinks_skip: '<div class="text-center col-md-12 py-2" style="margin-top:30px;"><b class="text-primary">Important:</b> You can skip this step by pressing the button below, however your approval chances may be impacted.<br><br><small>By providing your bank login details, you confirm you are aware of any contractual obligations with your financial institution.</small></div>',
            comparehub_member_pp_tc: `By creating an account you will become a CompareHub member and will receive access to learning resources, personalized recommendations and the option to obtain your free Equifax credit score. For more information please review our <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Privacy Policy</a> and <a href="https://loanscanada.ca/terms/" target="_blank">Terms of Use</a>. This does not affect your credit score.`,
            create_comparehub_account_opt_in: `<p class="text-muted small">By creating an account you will become a CompareHub member and will receive access to learning resources, personalized recommendations and the option to obtain your free Equifax credit score. For more information please review our <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Privacy Policy</a> and <a href="https://loanscanada.ca/terms/" target="_blank">Terms of Use</a>. <b>This does not affect your credit score.</b></p>`,
            consent_text: `<p class="text-muted text-center my-3"><small>By completing this form I authorize the trusted financial services provider I've been matched with to obtain credit reports from credit reporting agencies to assess my credit history (this will not affect your credit score). My consent is valid until I notify the matched provider of its withdrawal.</small></p>`,
            opt_in_text: `<p class="text-muted text-center my-3"><small>By selecting 'Yes' you agree to receive promotions and updates from {brand} & CompareHub.</small></p>`,
        },
        textBottomBelowActionButtons: {
            credit_history_authorization_1: `
                <p class="text-center" style="font-size:13px; color:#aaa;">{credit_history_authorization_1}</p>
            `,
            credit_history_authorization_1_car_loan: `
                <p class="text-center" style="font-size:13px; color:#aaa;">{credit_history_authorization_1_car_loan}</p>
            `
        }
    },
    fields: {
        labels: {
            requested_amount: 'How much would you like to borrow?',
            rent_mortgage_payment: 'Rent/Mortgage Payment',
            property_value: 'Property Value',
            property_mortgage: 'Property Mortgage',
            first_name: 'First Name',
            last_name: 'Last Name',
            email_address: 'Email Address',
            confirm_email: 'Confirm your email address',
            phone: 'Phone',
            phone_number: 'Phone Number',
            employer_name: 'Employer Name',
            job_title: 'Occupation',
            phone_number_work: 'Work Phone',
            address_civic_number: 'Civic Number',
            address_street: 'Street',
            address_unit_number: 'Unit Number',
            address_postal_code: 'Postal Code',
            address_city: 'City',
            address_province: 'Province',
            password: 'Password',
            confirm_password: 'Confirm your password',
            dob: 'What is your date of birth?',
            sin_optional: 'SIN (Optional)',
            your_address: 'Your Address',
            answer_not_provided: 'The answer was not provided.',
            monthly_income: 'Monthly Income',
            monthly_income_employment: 'Monthly Employment Income',
            monthly_income_pension: 'Monthly Retirement Income',
            monthly_other_income: 'Other Monthly Income',
            postal_code: 'Postal Code',
            province: 'Province',
            last_years_income: 'Last Year\'s Income',
            year_before_last_income: 'Year before last\'s income',
            liquid_equity: `Liquid equity <br>(cash, stocks, bonds, ETFs)`,
            non_liquid_equity: `Non-liquid equity <br>(equipment, real estate, vehicles)`,
            company_name: 'Company Name',
            gross_sales_monthly: 'Gross sales (monthly)',
            gross_sales_cards: 'Gross sales (cards only)',
            industry: 'Industry',
            payment_processor: 'Who is your payment processor?',
        },
        options: {
            opt_yes: "Yes",
            opt_no: "No",
            opt_not_right_now: "Not right now",
            //requested_amount
            opt_1000_less: "$1,000 or less",
            opt_1001_5000: "$1,001 to $5,000",
            opt_5001_10000: "$5,001 to $10,000",
            opt_10001_15000: "$10,001 to $15,000",
            opt_15001_20000: "$15,001 to $20,000",
            opt_20000_more: "More than $20,000",
            opt_20001_50000: "$20,001 to $50,000",
            opt_50000_more: "More than $50,000",
            // product_purpose
            opt_debt_consolidation: "Debt Consolidation",
            opt_cc_consolidation: "Credit Card Consolidation",
            opt_emergency_expense: "Emergency Expense",
            opt_car_repair: "Car Repair",
            opt_other: "Other",
            // cc_debt_amount
            // unsecured_debt_amount
            opt_debt_amounts_5000_less: "Less than $5,000",
            opt_debt_amounts_5001_10000: "$5,001 to $10,000",
            opt_debt_amounts_10001_15000: "$10,001 to $15,000",
            opt_debt_amounts_15001_20000: "$15,001 to $20,000",
            opt_debt_amounts_20001_25000: "$20,001 to $25,000",
            opt_debt_amounts_25000_more: "More than $25,000",
            // in_credit_situation
            opt_in_credit_situation_good: "Good (Over 700)",
            opt_in_credit_situation_fair: "Fair (550 - 700)",
            opt_in_credit_situation_low: "Low (Under 550)",
            opt_in_credit_situation_cp: "Current Consumer Proposal",
            opt_in_credit_situation_bk: "Current Bankruptcy",
            opt_in_credit_situation_unknown: "Not Sure",
            // income_type
            opt_income_type_full: "Full-Time Employed",
            opt_income_type_part: "Part-Time Employed",
            opt_income_type_self: "Self-Employed",
            opt_income_type_benefits: "Child Tax Benefits / EI",
            opt_income_type_disability: "Disability",
            opt_income_type_pension: "Pension / CPP / OAS",
            opt_income_type_unemployed: "Not Working",
            opt_income_type_other: "Other",
            //other income types
            opt_income_type_other_wsib: "WSIB",
            opt_income_type_other_short_term_disability: "Short Term Disability",
            opt_income_type_other_long_term_disability: "Long Term Disability",
            opt_income_type_other_social_security: "Employment insurance",
            opt_income_type_other_child_tax_benefit: "Child Tax Benefit",
            opt_income_type_other_rental_income: "Rental Income",
            opt_income_type_other_other: "Other",
            opt_income_type_other_none: "None",
            // monthly_income
            opt_1500_less: "$1500 or less",
            opt_1501_2000: "$1501 to $2000",
            opt_2001_3000: "$2001 to $3000",
            opt_3001_4000: "$3001 to $4000",
            opt_4001_5000: "$4001 to $5000",
            opt_5000_more: "More than $5000",
            // employed_months
            opt_employed_months_3_less: "Under 3 months",
            opt_employed_months_3_6: "3 to 6 months",
            opt_employed_months_6_12: "6 to 12 months",
            opt_employed_months_12_more: "1 year or more",
            // pay_frequency
            opt_weekly: "Weekly",
            opt_bi_weekly: "Bi-Weekly",
            opt_semi_monthly: "Semi-Monthly",
            opt_monthly: "Monthly",
            // address_length_months
            opt_address_length_months_3_less: "Under 3 months",
            opt_address_length_months_3_6: "3 to 6 months",
            opt_address_length_months_6_12: "6 to 12 months",
            opt_address_length_months_12_more: "1 year or more",
            // opt_in & credit consent
            opt_opt_in_consent: `Receive promotions and updates from {brand} by email. You can opt-out at any time. By clicking ‘Next' you agree to the <a href="https://loanscanada.ca/terms/" target="_blank">terms of use</a> and <a href="https://loanscanada.ca/privacy-policy/" target="_blank">privacy policy</a>.`,
            opt_opt_in_consent_by_lc: `Receive promotions and updates from {brand} by Loans Canada by email. You can opt-out at any time. By clicking ‘Next' you agree to the <a href="https://loanscanada.ca/terms/" target="_blank">terms of use</a> and <a href="https://loanscanada.ca/privacy-policy/" target="_blank">privacy policy</a>.`,
            opt_opt_in_consent_by_comparehub: `Receive promotions and updates from {brand} by CompareHub by email. You can opt-out at any time. By clicking ‘Next' you agree to the <a href="https://loanscanada.ca/terms/" target="_blank">terms of use</a> and <a href="https://loanscanada.ca/privacy-policy/" target="_blank">privacy policy</a>.`,
            opt_credit_auth_1: 'Show me other options',
            opt_credit_auth_2: 'Maximize my approval chances',
            // canadian status
            opt_cs_citizen: "Citizen",
            opt_cs_permanent: "Permanent Resident",
            opt_cs_work: "Work Permit",
            opt_cs_student: "Student Visa",
            opt_cs_visitor: "Visitor",
            opt_cs_other: "Other",
            // options_opt_in
            opt_continue_with_consent_yes: "Yes, and show me my loan options!",
            opt_continue_with_consent_no: "Continue to my loan options only",
            // car_request_type
            opt_car_type_sedan: 'Car',
            opt_car_type_suv: 'SUV',
            opt_car_type_van: 'Van',
            opt_car_type_truck: 'Truck',
            // car_request_monthly_budget
            opt_car_budget_200_less: 'Up to $200',
            opt_car_budget_201_350: '$201 to $350',
            opt_car_budget_351_500: '$351 to $500',
            opt_car_budget_501_more: '$501 or more',
            // life insurance
            //requested_amount
            opt_100k_less: "$100,000 or less",
            opt_100k_250k: "$100,001 to $250,000",
            opt_250k_500k: "$250,001 to $500,000",
            opt_500k_1m: "$500,001 to $1,000,000",
            opt_1m_more: "More than $1,000,000",
            // title
            opt_title_male: "Male",
            opt_title_female: "Female",
            // powersports
            opt_powersports_rv: "RVs",
            opt_powersports_boat: "Boats",
            opt_powersports_tractor: "Garden Tractors",
            opt_powersports_atv: "All-Terrain Vehicles (ATVs)",
            opt_powersports_motorcycle: "Motorcycles",
            opt_powersports_snowmobile: "Snowmobiles",
            opt_powersports_ebike: "E-bikes",
            opt_powersports_personalwatercraft: 'Personal Watercraft <span style="font-size: 0.75rem; display:block;">(e.g., Jet Skis, Sea-Doos, Boats)</span>',
            opt_powersports_camper: "Campers",
            opt_powersports_heavyequipment: "Heavy Equipment",
            // business loan
            // - business_type
            opt_business_type_accounting: "ACCOUNTING",
            opt_business_type_agriculture: "AGRICULTURE FARMING",
            opt_business_type_animal_boarding: "ANIMAL BOARDING",
            opt_business_type_apparel_accessories: "APPAREL ACCESSORIES",
            opt_business_type_auto_dealership: "AUTO TRUCK DEALERSHIP",
            opt_business_type_auto_body: "AUTO BODY",
            opt_business_type_auto_rental: "AUTO RENTAL",
            opt_business_type_beauty_barber: "BEAUTY SALON BARBER SHOP",
            opt_business_type_building_materials: "BUILDING MATERIALS",
            opt_business_type_business_services: "BUSINESS SERVICES",
            opt_business_type_car_wash: "CAR WASH",
            opt_business_type_cellular_store: "CELLULAR WIRELESS STORE",
            opt_business_type_child_education: "CHILD EDUCATION",
            opt_business_type_consulting: "CONSULTING",
            opt_business_type_day_care: "DAY CARE SERVICES",
            opt_business_type_doctor: "DOCTOR",
            opt_business_type_electronics_computers: "ELECTRONICS COMPUTERS",
            opt_business_type_entertainment: "ENTERTAINMENT",
            opt_business_type_equipment_rental: "EQUIPMENT RENTAL",
            opt_business_type_fabrication: "FABRICATION",
            opt_business_type_financial_services: "FINANCIAL SERVICES",
            opt_business_type_franchise: "FRANCHISE",
            opt_business_type_funeral_home: "FUNERAL HOME",
            opt_business_type_gaming: "GAMING",
            opt_business_type_gas_station: "GAS STATION",
            opt_business_type_general_contractor: "GENERAL CONTRACTOR",
            opt_business_type_general_merchandise_store: "GENERAL MERCHANDISE STORE",
            opt_business_type_grocery_convenience_store: "GROCERY CONVENIENCE STORE",
            opt_business_type_guns_ammunition_store: "GUNS AMMUNITION STORE",
            opt_business_type_gym_fitness_trainer: "GYM FITNESS TRAINER",
            opt_business_type_health_services: "HEALTH SERVICES",
            opt_business_type_home_furnishings: "HOME FURNISHINGS",
            opt_business_type_hotel_motel: "HOTEL/MOTEL",
            opt_business_type_hvac: "HVAC",
            opt_business_type_insurance_brokers: "INSURANCE BROKERS",
            opt_business_type_internet_retailer: "INTERNET RETAILER",
            opt_business_type_landscaping_services: "LANDSCAPING SERVICES",
            opt_business_type_laundry_garment_services: "LAUNDRY GARMENT SERVICES",
            opt_business_type_law_firm: "LAW FIRM",
            opt_business_type_legal_counsel: "LEGAL COUNSEL",
            opt_business_type_locksmith: "LOCKSMITH",
            opt_business_type_manufacturing: "MANUFACTURING",
            opt_business_type_marketing: "MARKETING",
            opt_business_type_media_production: "MEDIA PRODUCTION",
            opt_business_type_medical_healthcare: "MEDICAL HEALTHCARE",
            opt_business_type_nail_salon: "NAIL SALON",
            opt_business_type_oil_industry: "OIL INDUSTRY",
            opt_business_type_other: "OTHER",
            opt_business_type_photography_studio: "PHOTOGRAPHY STUDIO",
            opt_business_type_pool_services: "POOL SERVICES",
            opt_business_type_printing: "PRINTING",
            opt_business_type_real_estate_related: "REAL ESTATE RELATED",
            opt_business_type_recreation: "RECREATION",
            opt_business_type_residential_contractor: "RESIDENTIAL CONTRACTOR",
            opt_business_type_restaurant_cafe_bar: "RESTAURANT CAFE BAR",
            opt_business_type_retail_store: "RETAIL STORE",
            opt_business_type_sanitation: "SANITATION",
            opt_business_type_security_services: "SECURITY SERVICES",
            opt_business_type_senior_care_assisted_living: "SENIOR CARE ASSISTED LIVING",
            opt_business_type_smoke_shop: "SMOKE SHOP",
            opt_business_type_solar: "SOLAR",
            opt_business_type_spa_services: "SPA SERVICES",
            opt_business_type_staffing: "STAFFING",
            opt_business_type_tanning_salon: "TANNING SALON",
            opt_business_type_tax_preparation: "TAX PREPARATION",
            opt_business_type_technology_company: "TECHNOLOGY COMPANY",
            opt_business_type_travel_transportation: "TRAVEL TRANSPORTATION",
            opt_business_type_uniform_supplier: "UNIFORM SUPPLIER",
            opt_business_type_veterinary_clinic: "VETERINARY CLINIC",
            opt_business_type_waste_management: "WASTE MANAGEMENT",
            opt_business_type_wholesaler: "WHOLESALER",
            opt_business_type_wine_liquor_store: "WINE LIQUOR STORE",
            // - payment_processor
            opt_business_payment_processor_chase_paymentech: "CHASE PAYMENTECH",
            opt_business_payment_processor_debitech: "DEBITECH",
            opt_business_payment_processor_desjardins: "DESJARDINS",
            opt_business_payment_processor_elavon: "ELAVON",
            opt_business_payment_processor_everlink: "EVERLINK",
            opt_business_payment_processor_first_data: "FIRST DATA",
            opt_business_payment_processor_global_payments: "GLOBAL PAYMENTS",
            opt_business_payment_processor_mercury_payments: "MERCURY PAYMENTS",
            opt_business_payment_processor_moneris: "MONERIS",
            opt_business_payment_processor_monex: "MONEX",
            opt_business_payment_processor_payfirma: "PAYFIRMA",
            opt_business_payment_processor_pivotal_payments: "PIVOTAL PAYMENTS",
            opt_business_payment_processor_pos_west: "POS WEST",
            opt_business_payment_processor_square: "SQUARE",
            opt_business_payment_processor_stripe: "STRIPE",
            opt_business_payment_processor_td_merchant_services: "TD MERCHANT SERVICES",
            opt_business_payment_processor_other: "OTHER",
            opt_business_payment_processor_none: "NONE",
        },
        placeholders: {
            select: "Select...",
            your_email: "your@email.com",
            income_type: "Select your main income source...",
            income_type_other: "Please specify...",
            type_to_search: "Type to search...",
            address_number: 'Number',
            address_street: 'Street',
            address_unit: 'Apt 8, Suite 2, etc. (optional)',
            address_city: "City",
            select_date: "Select date...",
        },
        textBottom: {
            phone_number_sms_results: '<small style="display: block; font-size: 0.7em; padding-left: 2px; margin-top: -14px;">You will receive a 1-time SMS with your results (reply "STOP" to stop).</small>'
        }
    },
    buttons: {
        submit: 'Submit',
        skip: 'Skip',
        address_not_listed: 'My address is not listed',
        next: 'Next',
        request_code: 'Request Code',
        request_another_code: 'Request Another Code',
        edit: 'Edit'
    }
}
